import { render, staticRenderFns } from "./MultiMonitorToggle.vue?vue&type=template&id=58c9bf3f"
import script from "./MultiMonitorToggle.vue?vue&type=script&lang=js"
export * from "./MultiMonitorToggle.vue?vue&type=script&lang=js"
import style0 from "./MultiMonitorToggle.vue?vue&type=style&index=0&id=58c9bf3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports